import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import InstructionVideoUploadForm from './InstructionVideoUploadForm';
import InstructionVideoUploadService from './../services/InstructionVideoUploadService';

class InstructionVideoUploadFormContainer extends React.Component {
  static propTypes = {
    instructionVideoId: PropTypes.string.isRequired,
    selectedLocales: PropTypes.array,
  };

  static defaultProps = {
    selectedLocales: [],
  };

  componentDidMount() {
    InstructionVideoUploadService.init(this.props.instructionVideoId);
  }

  render() {
    return (
      <InstructionVideoUploadForm
        onSubmit={InstructionVideoUploadService.handleSubmit}
        onChange={InstructionVideoUploadService.form.setValue}
        errors={InstructionVideoUploadService.form.errors}
        values={InstructionVideoUploadService.form.getValues()}
        submitting={InstructionVideoUploadService.submit.fetching}
        selectedLocales={this.props.selectedLocales}
      />
    );
  }
}

export default observer(InstructionVideoUploadFormContainer);
